import { useQuery } from '@apollo/client'
import { USUARIOS_PORTAL_PROPERTIES_QUERY } from '../data/usuarios-portal-properties'
import { OptionSelect } from '@/core/utils/types'
import { BaseEnum, Maybe } from '@/core/types/graphql'

export const useUsuariosPortalProperties = () => {
  const { data } = useQuery(USUARIOS_PORTAL_PROPERTIES_QUERY, {
    fetchPolicy: 'network-only'
  })

  const tiposUsuarioInformarCargo: Array<Maybe<BaseEnum>> =
    data?.usuariosPortalProperties?.tiposUsuarioInformarCargo ?? []

  const tiposUsuarioInformarGestao: Array<Maybe<BaseEnum>> =
    data?.usuariosPortalProperties?.tiposUsuarioInformarGestao ?? []

  const isInformarCargo = (tipo: OptionSelect) => {
    return tiposUsuarioInformarCargo.some(tu => tu?.id === tipo.value)
  }

  const isInformarGestao = (tipo: OptionSelect) => {
    return tiposUsuarioInformarGestao.some(tu => tu?.id === tipo.value)
  }

  const isInformarDepartamentoCargo: boolean =
    data?.usuariosPortalProperties?.informarDepartamentoCargo ?? false

  return {
    isInformarCargo,
    isInformarGestao,
    isInformarDepartamentoCargo
  }
}
